import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto p-6 text-gray-800">
      <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
      <p className="mb-4 text-center text-gray-600">Effective Date: Launch Date</p>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
        <p>
          Welcome to <strong>Bliss Distro</strong>. Your privacy is of utmost importance to us. This Privacy Policy outlines the types of information we collect, how we use and safeguard it, and the choices available to you regarding your personal data. By using our platform, you agree to the collection and use of information in accordance with this policy.
        </p>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">2. Information We Collect</h2>
        <p>
          We collect various types of information to provide and improve our services. The data we collect includes but is not limited to:
        </p>
        <ul className="list-disc ml-6">
          <li><strong>Personal Information:</strong> Your name, email address, phone number, and payment details.</li>
          <li><strong>Content Data:</strong> Uploaded music files, album artwork, track metadata, and descriptions.</li>
          <li><strong>Technical Data:</strong> IP address, browser type, operating system, and usage statistics.</li>
          <li><strong>Communication Data:</strong> Correspondence with our support team and feedback provided.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">3. How We Use Your Information</h2>
        <p>
          The data we collect is used for the following purposes:
        </p>
        <ul className="list-disc ml-6">
          <li>To facilitate music distribution across streaming platforms.</li>
          <li>To process transactions, payouts, and royalty distributions securely.</li>
          <li>To personalize user experience and improve our services.</li>
          <li>To detect and prevent fraud, unauthorized access, and security threats.</li>
          <li>To communicate updates, promotional materials, and support messages (with user consent).</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">4. Data Sharing and Third Parties</h2>
        <p>
          We do not sell or trade your personal information. However, we may share data with:
        </p>
        <ul className="list-disc ml-6">
          <li><strong>Streaming Services:</strong> We share relevant data with platforms like Spotify, Apple Music, and other distributors to facilitate music releases.</li>
          <li><strong>Payment Processors:</strong> We use secure third-party payment gateways to handle transactions.</li>
          <li><strong>Legal Authorities:</strong> If required by law, we may disclose information in compliance with legal obligations.</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">5. Data Security</h2>
        <p>
          We prioritize the security of your data by implementing robust security measures, including encryption and access controls. While we strive to protect your information, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">6. Your Rights</h2>
        <p>
          You have the following rights regarding your personal data:
        </p>
        <ul className="list-disc ml-6">
          <li><strong>Access & Correction:</strong> You can request a copy of your personal data and correct inaccuracies.</li>
          <li><strong>Data Deletion:</strong> You may request the deletion of your data, subject to legal and contractual obligations.</li>
          <li><strong>Marketing Preferences:</strong> You can opt-out of promotional communications at any time.</li>
        </ul>
      </section>
      
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">7. Cookies and Tracking Technologies</h2>
        <p>
          Our website uses cookies to enhance user experience, analyze traffic, and provide personalized content. You can manage your cookie preferences through your browser settings.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. We will notify you of any significant changes via email or on our website.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-3">9. Contact Us</h2>
        <p>
          If you have any questions or concerns about this Privacy Policy, please contact us at:
        </p>
        <p className="font-medium">
          Email: <a href="mailto:support@[yourwebsite].com" className="text-blue-600 hover:underline">support@blissdistro.com</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
